import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 14 50"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#8F8E89",
      "stroke-linejoin": "round",
      "stroke-width": "1.6",
      d: "M1 50V31l-.5-5 .5-5V1h12v20l.5 5-.5 5v19zM1 21h12.5M1 31h12.5M0 26h14"
    }, null, -1)
  ])))
}
export default { render: render }